import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/cookiebar/index';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
import './components/Title';
$.fancybox.defaults.backFocus = false;
// import './wwdev/webshop/index.js';
// import '@wwdev/myaccount/index.js';
// import '@wwdev/register';
// import '@wwdev/search';
import '@wwdev/contentable';
import '@wwdev/shared';
import '@wwdev/functions/setEqualHeightsPerRow';
import './externals/hamburgers.js';
import './externals/swiper';
import './externals/isotope';
import './externals/animate';

// Sections
import './sections/PartnerSlider';
import './sections/AnimatedScroll';
import './sections/Team';
import './sections/Vacatures';
import './sections/Cards2';
import './sections/Visual';

